import { motion } from 'framer-motion';
import { Truck } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Official USA Pickleball mark — sits under the Explore CTA
export const HeroCredentials = ({ delay = 1.0 }) => (
  <motion.div
    className="flex items-center gap-1.5 sm:gap-2"
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    data-testid="hero-trust-badges"
  >
    <img
      src={`${API}/static/brand/usap_logo_white.webp`}
      alt="USA Pickleball"
      width="579"
      height="294"
      draggable={false}
      className="h-[26px] sm:h-7 md:h-8 w-auto select-none opacity-90 drop-shadow-[0_2px_8px_rgba(0,0,0,0.6)]"
      data-testid="hero-usap-badge"
    />
    <img
      src={`${API}/static/brand/pbcor_approved_white.webp`}
      alt="PBCoR .43 Approved"
      width="1291"
      height="173"
      draggable={false}
      className="h-5 sm:h-[23px] md:h-[27px] w-auto select-none opacity-90 drop-shadow-[0_2px_8px_rgba(0,0,0,0.6)]"
      data-testid="hero-pbcor-badge"
    />
  </motion.div>
);

// Shipping note — pinned at the very top of the hero, right under the header
export const HeroShippingNote = ({ delay = 0.6 }) => (
  <motion.div
    className="flex items-center gap-3 opacity-90 hover:opacity-100 transition-opacity duration-300"
    initial={{ opacity: 0, y: -8 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    data-testid="hero-shipping-badge"
  >
    <Truck className="w-6 h-6 sm:w-7 sm:h-7 text-white shrink-0" strokeWidth={1.6} />
    <span className="font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.28em] text-zinc-300 whitespace-nowrap">
      Shipping across <span className="font-heading font-bold text-white tracking-[0.18em]">India</span>
    </span>
  </motion.div>
);
